import Headroom from 'headroom.js';
import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
import YTPlayer from 'yt-player';
import { Modal } from 'bootstrap';

const syMenu = () => {
	const burger    = document.querySelector('.sy_header button');
	const overlay   = document.querySelector('.sy_overlay');
	const close     = document.querySelector('.sy_overlay-close');
	const menuItems = document.querySelectorAll('.sy_overlay .nav-link');

	for (let i = 0; i < menuItems.length; i++) {
		const el = menuItems.item(i);

		el.addEventListener('click', () => {
			overlay.classList.remove('active');
			document.body.classList.remove('overflow-hidden');
		});
	}

	burger.addEventListener('click', () => {
		overlay.classList.add('active');
		document.body.classList.add('overflow-hidden');
	})

	close.addEventListener('click', () =>  {
		overlay.classList.remove('active');
		document.body.classList.remove('overflow-hidden');
	})
}

const syFilter = () => {
	if(document.body.contains(document.querySelector('.sy_filter'))) {
		const form 		= document.querySelector('.sy_filter form');
		
		form.addEventListener('submit', function(event) {
			event.preventDefault();

			var locality 	= document.querySelector('[name="sy_filter-locality"]');
			var position 	= document.querySelector('[name="sy_filter-position"]');

			let positionOption 	= document.querySelector('option[value="' + position.value + '"]');

			let positionLink 	= positionOption.getAttribute('data-link');			
			if(locality.value == 'locality_all') {
				window.location.assign(positionLink);
			} else {
				window.location.assign(positionLink + '?locality=' + locality.value);
			}
		});

		var getUrlParameter = function getUrlParameter(sParam) {
			var sPageURL = window.location.search.substring(1),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === sParam) {
					return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
				}
			}
			return false;
		};

		if(getUrlParameter('locality')) {
			document.querySelector('[name="sy_filter-locality"]').value = getUrlParameter('locality');
			const sections 	= document.querySelectorAll('section.sy_positions');
			
			for (let i = 0; i < sections.length; i++) {
				const el = sections[i];
				el.classList.add('d-none')
			}

			let shownLocality 	= document.querySelector('.sy_positions[data-locality="' + getUrlParameter('locality') +'"]');
			shownLocality.classList.remove('d-none');
		}
	}
}

const syVideo = () => {
	if(document.body.contains(document.querySelector('#player'))) {
		const player 	= new YTPlayer('#player',[{
			'modestBranding': true,
			'related': false,
		}]);

		var videoModalEl = document.getElementById('videoModal');
		var videoModal 	= new Modal(videoModalEl);

		videoModalEl.addEventListener('shown.bs.modal', function (event) {
			let desktopVideo 	= event.target.getAttribute('data-video-desktop');

			player.load(desktopVideo, true);	
			player.play();
		});

		videoModalEl.addEventListener('hidden.bs.modal', function () {
			player.stop();
		});

		player.on('ended', () => {
			videoModal.hide();
		})
	}
}

const syStickyHeader = () => {
	const header = document.querySelector('.sy_header');
	const headroom = new Headroom(header);
	headroom.init();
}

const syNews = () => {
	if(document.body.contains(document.querySelector('.sy_news .swiper'))) {
		// eslint-disable-next-line no-unused-vars
		const positionsSlider = new Swiper('.sy_news .swiper', {
			speed: 400,
			slidesPerView: 1,
			breakpoints: {
				'768': {
					slidesPerView: 2,
					spaceBetween: 14,
				},
				'992': {
					slidesPerView: 3,
					spaceBetween: 14,
				},
				'1296': {
					slidesPerView: 4,
					spaceBetween: 14,
				},
			},
		});
	}
}

const syPositions = () => {
	if(document.body.contains(document.querySelector('.sy_positions .swiper'))) {
		// eslint-disable-next-line no-unused-vars
		const positionsSlider = new Swiper('.sy_positions .swiper', {
			speed: 400,
			modules: [Pagination],
			slidesPerView: 1,
			breakpoints: {
				'768': {
					slidesPerView: 2,
					spaceBetween: 14,
				},
				'992': {
					slidesPerView: 3,
					spaceBetween: 14,
				},
				'1296': {
					slidesPerView: 4,
					spaceBetween: 14,
				},
			},
			pagination: {
				el: '.sy_positions-pagination',
				type: 'bullets',
			},
		});
	}
}

const syReliazations = () => {
	if(document.body.contains(document.querySelector('.sy_realizations .swiper'))) {
		// eslint-disable-next-line no-unused-vars
		const realizationsSlider = new Swiper('.sy_realizations .swiper', {
			speed: 400,
			modules: [Navigation, Autoplay],
			slidesPerView: 1,
			autoplay: true,
			breakpoints: {
				'1296': {
					slidesPerView: 2,
					autoHeight: true,
				},
			},
			navigation: {
				nextEl: '.sy_realizations-arrow--next',
				prevEl: '.sy_realizations-arrow--prev',
			},
		});
	}
}

const syReliazationsSlider = () => {
	if(document.body.contains(document.querySelector('.sy_realizations-slider .swiper'))) {
		// eslint-disable-next-line no-unused-vars
		const realizationsSlider = new Swiper('.sy_realizations-slider .swiper', {
			speed: 400,
			slidesPerView: 1,
			modules: [Pagination],
			pagination: {
				el: '.sy_realizations-slider-navigation',
				clickable: true,
				renderBullet: function (index, className) {
					index++;
					let number = index.toString().padStart(2, 0);
					return '<span class="' + className + '">' + (number) + '</span>';
				},
			},
		});
	}
}

const syBenefits = () => {
	if(document.body.contains(document.querySelector('.sy_benefits [data-swiper]'))) {
	
		(function() {

			'use strict';
			const breakpoint = window.matchMedia( '(min-width:992px)' );
			let benefitsSlider;

			const breakpointChecker = function() {
				if ( breakpoint.matches === true ) {
					if ( benefitsSlider !== undefined ) {
						benefitsSlider.destroy( true, true );
						document.querySelector('.sy_benefits [data-swiper]').classList.remove('swiper');
						document.querySelector('.sy_benefits [data-swiper-wrapper]').classList.remove('swiper-wrapper');
						let benefitsSlides 	= document.querySelectorAll('.sy_benefits [data-swiper-item]');
						for (let i = 0; i < benefitsSlides.length; i++) {
							const el = benefitsSlides[i];
							el.classList.remove('swiper-slide')
						}
						return;
					} 

				} else if ( breakpoint.matches === false ) {
					document.querySelector('.sy_benefits [data-swiper]').classList.add('swiper');
					document.querySelector('.sy_benefits [data-swiper-wrapper]').classList.add('swiper-wrapper');
					let benefitsSlides 	= document.querySelectorAll('.sy_benefits [data-swiper-item]');
					for (let i = 0; i < benefitsSlides.length; i++) {
						const el = benefitsSlides[i];
						el.classList.add('swiper-slide')
					}

					return enableSwiper();
				}
			};

			const enableSwiper = function() {
				// eslint-disable-next-line no-unused-vars
				benefitsSlider = new Swiper('.sy_benefits .swiper', {
					modules: [Pagination],
					speed: 400,
					slidesPerView: 1,
					centeredSlides: true,
					pagination: {
						el: '.sy_benefits-pagination',
						type: 'bullets',
					},
				});
			};

			breakpoint.addListener(breakpointChecker);
			breakpointChecker();
		})();
	}
}

const syStats = () => {
	if(document.body.contains(document.querySelector('.sy_stats [data-swiper]'))) {
	
		(function() {

			'use strict';
			const breakpoint = window.matchMedia( '(min-width:992px)' );
			let benefitsSlider;

			const breakpointChecker = function() {
				if ( breakpoint.matches === true ) {
					if ( benefitsSlider !== undefined ) {
						benefitsSlider.destroy( true, true );
						document.querySelector('.sy_stats [data-swiper]').classList.remove('swiper');
						document.querySelector('.sy_stats [data-swiper-wrapper]').classList.remove('swiper-wrapper');
						let statsSlides 	= document.querySelectorAll('.sy_stats [data-swiper-item]');
						for (let i = 0; i < statsSlides.length; i++) {
							const el = statsSlides[i];
							el.classList.remove('swiper-slide')
						}
						return;
					} 

				} else if ( breakpoint.matches === false ) {
					document.querySelector('.sy_stats [data-swiper]').classList.add('swiper');
					document.querySelector('.sy_stats [data-swiper-wrapper]').classList.add('swiper-wrapper');
					let statsSlides 	= document.querySelectorAll('.sy_stats [data-swiper-item]');
					for (let i = 0; i < statsSlides.length; i++) {
						const el = statsSlides[i];
						el.classList.add('swiper-slide')
					}

					return enableSwiper();
				}
			};

			const enableSwiper = function() {
				// eslint-disable-next-line no-unused-vars
				benefitsSlider = new Swiper('.sy_stats .swiper', {
					modules: [Pagination],
					speed: 400,
					slidesPerView: 1,
					centeredSlides: true,
					pagination: {
						el: '.sy_stats-pagination',
						type: 'bullets',
					},
				});
			};

			breakpoint.addListener(breakpointChecker);
			breakpointChecker();
		})();
	}
}

const syScroll = () => {
	if(document.body.contains(document.querySelector('.sy_hero-scroll'))) {
		const scrollBtn	 	= document.querySelector('.sy_hero-scroll');
		const scrollTarget	= document.querySelector('.sy_links');
		scrollBtn.addEventListener('click', () => {
			scrollTarget.scrollIntoView({
				'behavior': 'smooth',
			});
		})
	}
}

const initSyner = () => {
	// swipers
	syBenefits();
	syPositions();
	syReliazations();
	syNews();
	syStats();
	syReliazationsSlider();

	// header
	syMenu();

	// video 
	syVideo();

	// filter
	syFilter();

	// scroll btn
	syScroll();

	// menu
	syStickyHeader();
}

document.addEventListener('DOMContentLoaded', () => {
	initSyner();
});
